<template>
  <div class='navbar'>
    <div>
      <a href='/' class='logo'>
        <img alt="Peg logo" src="../assets/logo.png">
      </a>

      <div class='nav-links'>
        <router-link to="/subscriptions">Subscriptions</router-link>
        <router-link to="/users">Users</router-link>
        <span class="divider"></span>
        <a :href="pegUrl('backroom-d') + '/influencers'">Influencers</a>
        <a :href="pegUrl('backroom-d') + '/brands'">Brands</a>
      </div>
    </div>

    <div>
      <a :href='pegUrl("app")'>Return to Peg</a>
    </div>
  </div>
</template>

<script>
import rootUrl from '@/rootUrl'

export default {
  name: 'Navbar',
  methods: {
    pegUrl(subdomain) {
      return rootUrl({ subdomain })
    }
  }
}
</script>

<style scoped lang="stylus">
.divider {
  height: 20px;
  margin-top: 20px;
  border-left: 1px solid $grey;
}

.navbar {
  display: flex;
  border-bottom: 1px solid $grey;
  padding: 0px 30px;
  background: $white;
  margin-bottom: 0;
  width: 100%;
  justify-content: space-between;
  
  > div {
    height: 60px;
    display: flex;
    align-items: center;
  }
}

.logo {
  img {
    height: 32px;
    margin-right: $spacingLg;
    cursor: pointer;
    vertical-align: middle;
    border-style: none;
  }

  &::after {
    content: " ";
    position: absolute;
    height: 20px;
    top: 20px;
    border-left: 1px solid $grey;
  }
}

.nav-links {
  display: flex;
  height: 100%;

  a {
    display: inline-flex;
    align-items: center;
    padding: 0px $spacingLg;
    border-top: 2px solid transparent;
    border-bottom: 2px solid transparent;
    color: $midGrey;

    &:hover {
      color: $secondaryBlue;
    }

    &.router-link-active {
      color: $darkGrey;
      border-bottom: 2px solid $primaryBlue;
    }
  }
}

</style>
